import makeStyles from '@mui/styles/makeStyles';

const FormStyles = makeStyles({
    inputLabelStyle: {
        fontSize: 18,
        lineHeight: 1.2,
        color: "#4d4e50",
        position: "relative",
        display: "contents"
    }
});

export default FormStyles;